import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import ChildSafetyPolicyText from "../../global-components/src/components/child-safety-policy-text";

const ChildSafetyPolicy = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Política de Segurança Infantil">
                <Helmet>
                        <title>Paçoca - Política de Segurança Infantil</title>
                        <meta name="description" content={`Visualize as Política de Segurança Infantil do Paçoca`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Política de Segurança Infantil, termos, regras}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Política de Segurança Infantil`}/>
                        <meta property="og:description" content={`Visualize as Política de Segurança Infantil do Paçoca`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Política de Segurança Infantil`}/>
                        <meta name="twitter:description" content={`Visualize as Política de Segurança Infantil do Paçoca`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet> 

                <div className="padding-big-screen">
                    <ChildSafetyPolicyText system="Paçoca: rede social brasileira"/>
                </div>
            </Screen>
        </>
    );
};

export default ChildSafetyPolicy;